import { Component, ViewChild, OnInit } from "@angular/core";
import { GlobalConstants } from "../common/global-constants";
import * as ngswal from "sweetalert";
import { customfunctions, DataParam } from "../common/customfunctions";
import { IngestionAPIModel } from "./Ingestion-model";
import { ApiMethod } from "../apimethods/api-method";
import { ActivatedRoute, Router } from "@angular/router";
declare var $;

@Component({
  selector: "app-ingestion",
  templateUrl: "./ingestion.component.html",
  styleUrls: ["./ingestion.component.css"]
})

/** Ingestion component*/
export class IngestionComponent implements OnInit {
  modelItem = new IngestionAPIModel();

  @ViewChild("dataTable", { static: false }) table;
  public aMenuList = [];
  dataTable: any;
  dtOptions: any;
  showModal: boolean;
  status: boolean = false;
  title: string;

  ingestTitle: string;
  ingestStatus: string;
  ingestStartDate: string;
  ingestCompleteDate: string;
  ingestDescription: string;

  uccStatus: string;
  uccStartDate: string;
  uccCompleteDate: string;
  uccDescription: string;
  ingesId: string;
  uploadTitle: string;
  fileToUpload: File = null;
  filePath: any;
  monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  public statusList = [];
  journalList: any;
  issueList: any;
  volumeList: any;
  dataSet: any;

  parameterStatus: string = "Failed";

  ngOnInit() {
    ApiMethod.getBaseUrl();

    this.route.queryParams
      .subscribe(params => {
        this.parameterStatus = GlobalConstants.GetTitleFormat(params.type);
      });
  }

  constructor(private router: Router, private route: ActivatedRoute) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <IngestionAPIModel>data["IngestionPage"];

        $(".select2").select2();

        $("#lstJournals").select2({
          placeholder: "Select Journal", dropdownParent: "#divMainFilter",
          allowClear: true, tags: true
        });
        $("#lstJournals").val([]).trigger("change");

        $("#lstVolume").select2({
          placeholder: "Select Volume", dropdownParent: "#divMainFilter",
          allowClear: true, tags: true
        });
        $("#lstVolume").val([]).trigger("change");

        $("#lstIssue").select2({
          placeholder: "Select Issue", dropdownParent: "#divMainFilter",
          allowClear: true, tags: true
        });
        $("#lstIssue").val([]).trigger("change");

        $("#lstStatus").select2({
          placeholder: "Select Status", dropdownParent: "#divMainFilter",
          allowClear: true, tags: true
        });
        $("#lstStatus").val([]).trigger("change");

        this.getIngestionStatus();
        this.getJournalsList();

        customfunctions.SetDateValues("#Txt_FromDate", "#Txt_ToDate");

        this.getIngestionList();
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  getIngestionList() {
    $("#LoadingImage").show();

    var fromDate = $("#Txt_FromDate").val();//'01/01/2021';
    var toDate = $("#Txt_ToDate").val();
    var selectedStatus = $("#lstStatus option:selected").text();
    if (this.parameterStatus != null && selectedStatus == '') {
      selectedStatus = GlobalConstants.GetTitleFormat(this.parameterStatus);
    }
    var ingestionData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      FromDate: fromDate.toString(),
      ToDate: toDate.toString(),
      SelectedStatus: selectedStatus,
      Journals: $("#lstJournals").val().toString(),
      Volume: $("#lstVolume option:selected").text(),
      Issue: $("#lstIssue option:selected").text()
    };

    ApiMethod.postMethod(this.modelItem.IngestionAPI, ingestionData).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.dataSet = JSON.stringify(result.aitemList);
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let acolList = result.acolListL;
        let dataItem = new DataParam();
        dataItem.acolList = acolList;
        dataItem.aNewButtonName = "";
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 285);
        dataItem.modulename = "IngestionModule";
        dataItem.infoPopupID = "IngestID";
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  getFiltered() {
    this.parameterStatus = "Failed";
    this.getIngestionList();
  }

  resetFilter() {
    this.parameterStatus = "Failed";
    customfunctions.SetDateValues("#Txt_FromDate", "#Txt_ToDate");
    $("#lstJournals").val(0).change();
    $("#lstVolume").val(0).change();
    $("#lstIssue").val(0).change();
    $("#lstStatus").val('Failed').change();
    this.getIngestionList();
  }

  getIngestionStatus() {
    ApiMethod.getMethod(this.modelItem.IngestionStatusAPI).subscribe(
      result => {
        this.statusList = result.aitemStatusList;
      }, error => {
        ngswal("Failed !", error.message, "error");
      });
  }

  show() {
    var ingestionData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      InstId: localStorage.aEID
    };

    ApiMethod.postMethod(this.modelItem.IngestionDetailsAPI, ingestionData).subscribe(
      result => {
        this.showModal = true;
        this.title = "Log Details";
        this.ingestTitle = result.PackageName;

        this.ingestStatus = result.StatusName;
        this.ingestStartDate = this.dateFormat(result.ReceivedDate);
        this.ingestCompleteDate = this.dateFormat(result.CompletedDate);
        this.ingestDescription = result.IngestInfo;

        this.uccStatus = result.UCCStatusName;
        this.uccStartDate = this.dateFormat(result.UCCReceivedDate);
        this.uccCompleteDate = this.dateFormat(result.UCCCompletedDate);
        this.uccDescription = result.UCCInfo;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  hide() {
    this.showModal = false;

    $("#divFileUpload").hide();
    $("#file").val("");
  }

  dateFormat(dateL) {
    try {
      var currentDate = "";

      if (dateL != null) {
        var date = new Date(dateL);

        var day = date.getDate();
        var dayString = day > 9 ? day : '0' + day;
        currentDate = dayString + ' ' + this.monthNames[date.getMonth()] + ' ' + date.getFullYear(); //month_names[date.getMonth()]
      }
      return currentDate;
    } catch (e) {
      return "";
    }
  }

  upload() {
    $("#LoadingImage").show();
    var ingestionData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      InstId: localStorage.aEID
    };

    ApiMethod.postMethod(this.modelItem.IngestionDetailsAPI, ingestionData).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.uploadTitle = result.PackageName;

        $("#divFileUpload").show();
        localStorage.UploadApi = this.modelItem.UploadFile;

        $(".upload").html("");
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  download() {
    ApiMethod.Downloadfile(this.modelItem.DownloadFile + "/" + localStorage.aLoginID + "/" + localStorage.aPubID + "/" + localStorage.aEID);
  }

  getJournalsList() {
    ApiMethod.getMethod(this.modelItem.GetJournalList + "/" + localStorage.aPubID + "/" + localStorage.aLoginID).subscribe(
      result => {
        this.journalList = result.aitemJournalList;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  getVolumeIssue() {
    var journals = $("#lstJournals").val().toString();

    ApiMethod.getMethod(this.modelItem.VolumeIssueListAPI + '/' + journals).subscribe(
      result => {
        this.volumeList = result.volumeList;
        this.issueList = result.issueList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }
}
